import type { CoreBrand, CoreState } from '../../types'
import { findActiveBrand } from '../common/findActiveBrand'

export const getActiveBrandHighestSubscriptionTier = (
  state: CoreState
): CoreBrand['metadata']['highestSubscriptionTier'] | null | undefined => {
  return findActiveBrand(state)?.metadata?.highestSubscriptionTier
}
